module.exports = __webpack_public_path__ + "img/img5.eb30fe2c.png";